import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import ImageIcon from "@mui/icons-material/ImageOutlined";
import DescriptionIcon from "@mui/icons-material/DescriptionOutlined";
import AudiotrackIcon from "@mui/icons-material/AudiotrackOutlined";
import MovieIcon from "@mui/icons-material/MovieOutlined";
import AttachFileIcon from "@mui/icons-material/AttachFileOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useGetOrderFilesQuery } from "app/api/orders";
import { useOrderContext } from "context/OrderContext";
import LoadingDisplay from "components/LoadingDisplay";
import ErrorDisplay from "components/ErrorDisplay";
import EmptyMessage from "components/EmptyMessage";
import { OrderFileType } from "models/OrderFile";

const FILE_TYPE_ICONS: Record<OrderFileType, React.ReactNode> = {
  IMG: <ImageIcon />,
  DOCUMENT: <DescriptionIcon />,
  AUDIO: <AudiotrackIcon />,
  MOVIE: <MovieIcon />,
  OTHER: <AttachFileIcon />,
};

const OrderFilesSection: React.FC = () => {
  const order = useOrderContext();
  const { data: files, isLoading, isError } = useGetOrderFilesQuery(order.ordernr);

  return (
    <Box p={1}>
      {isLoading ? (
        <LoadingDisplay message="Hämtar filer..." />
      ) : isError ? (
        <ErrorDisplay message="Kunde inte hämta filer" />
      ) : !files?.length ? (
        <EmptyMessage m={1}>Inga filer</EmptyMessage>
      ) : (
        <List disablePadding>
          {files.map((file) => (
            <ListItem key={file.id} disablePadding>
              {/* Files live on a third-party host; open them directly, never via the API client. */}
              <ListItemButton
                component="a"
                href={file.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ borderRadius: 2 }}
              >
                <ListItemIcon>{FILE_TYPE_ICONS[file.type] ?? FILE_TYPE_ICONS.OTHER}</ListItemIcon>
                <ListItemText primary={file.fileName || file.url} />
                <OpenInNewIcon fontSize="small" color="action" />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};

export default OrderFilesSection;
